import { render } from "./RegisterName.vue?vue&type=template&id=de8bb3fc"
import script from "./RegisterName.vue?vue&type=script&lang=js"
export * from "./RegisterName.vue?vue&type=script&lang=js"

import "./RegisterName.vue?vue&type=style&index=0&id=de8bb3fc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__